import checkTaxNumber from '../utils/check-tax-number';

export default function (app) {
	app.directive('cdvTaxNumber', function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, elem, attrs, ctrl) {
				var validate = function (viewValue) {
					if (viewValue) {
						var normalizedValue = viewValue.replace(/[^0-9]*/g, '');
						if (normalizedValue.length == 11) {
							angular.element('#cdvtaxnumberinvalid').css('display', checkTaxNumber(normalizedValue.substring(0, 10)) ? 'none' : 'block');
						} else {
							angular.element('#cdvtaxnumberinvalid').css('display', 'none');
						}
					} else {
						angular.element('#cdvtaxnumberinvalid').css('display', 'none');
					}
					return viewValue;
				};
				ctrl.$parsers.unshift(validate);
				ctrl.$formatters.unshift(validate);
			}
		};
	});
};
